import React from 'react'

export default function Formfieldstar(props) {
    

    return (
        <label><small className='amz_field_star' style={{color: '#E70F2E'}}> *</small></label>
    )
}